/*
 * metrics KPI 卡片块
 * Schema: MetricItem[] (直接是数组)
 */
import React from 'react'
import { tryParseJson, MetricItem, MetricColor } from './types'
import { useInvalidBlockWarning } from './useInvalidBlockWarning'
import './MetricsBlock.scss'

interface MetricsBlockProps {
  code: string
}

const COLOR_TREND: Record<MetricColor, string> = {
  green: '↗',
  red: '↘',
  yellow: '—',
  blue: '↗',
  default: ''
}

export const MetricsBlock: React.FC<MetricsBlockProps> = ({ code }) => {
  const data = tryParseJson<MetricItem[]>(code)

  // 流式中 JSON 未收齐时 silent 不渲染，避免闪"指标数据无效"（对齐 FileListBlock）；
  // 流式结束后仍无效 → useInvalidBlockWarning 会 console.warn 留排查线索
  const valid = Array.isArray(data) && data.length > 0
  useInvalidBlockWarning('metrics', code, valid)
  if (!Array.isArray(data) || data.length === 0) {
    return null
  }

  return (
    <div className="aiClerk-block-metrics">
      {data.map((m, i) => {
        const color = m.color || 'default'
        return (
          <div
            key={i}
            className={`aiClerk-block-metrics__card aiClerk-block-metrics__card--${color}`}
          >
            <div className="aiClerk-block-metrics__label">{m.label}</div>
            <div className="aiClerk-block-metrics__value">
              {m.value}
              {color !== 'default' && (
                <span className="aiClerk-block-metrics__trend">
                  {COLOR_TREND[color]}
                </span>
              )}
            </div>
            {m.sub && <div className="aiClerk-block-metrics__sub">{m.sub}</div>}
          </div>
        )
      })}
    </div>
  )
}
